/**
 * Root Layout
 * Main layout with header and footer for public pages
 */

import { Outlet } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { EnvironmentBadge } from '../components/EnvironmentBadge';
import { ToastContainer } from '../components/ToastContainer';

export function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <EnvironmentBadge />
      <ToastContainer />
    </div>
  );
}
